import { render, staticRenderFns } from "./InvitesCreate.vue?vue&type=template&id=858e7e74"
import script from "./InvitesCreate.vue?vue&type=script&lang=js"
export * from "./InvitesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports